module.exports = __webpack_public_path__ + "static/media/YGY-Logo-Icon-White.91ffd7e0.svg";